import { ChangeEvent } from 'react';
import { connect, FormikContextType } from 'formik';

import {
    InputDecorator,
    Props as InputWrapperProps,
    ValidationActions,
} from 'components/layout/forms/InputWrapper';

import Component from './component';


export interface Props extends InputWrapperProps {
    formik?: FormikContextType<any>;
    name: string;
    value?: string | number | boolean;
    onChange: (event: ChangeEvent<any>) => any;
    style?: InputStyles;
    styles?: object;
    error?: string;
    disabled?: boolean;
    validationAction?: ValidationActions;
    decoratorLeft?: InputDecorator;
    decoratorRight?: InputDecorator;
    expandable?: boolean;
}

export enum InputStyles {
    Primary = 'primary',
    Secondary = 'secondary',
}

Component.defaultProps = {
    value: '',
    style: InputStyles.Primary,
    styles: {},
    error: null,
    disabled: false,
    validationAction: ValidationActions.Decorator,
    decoratorLeft: null,
    decoratorRight: null,
    expandable: false,
};

export default connect(Component);